import React from "react";
import "./contact.css";
import { MapPin, Mail, Phone } from "lucide-react";
import whatsappIcon from "../../assets/whatsapp.png";

const Contact = () => {
  return (
    <section id="contact" className="contact-section">
      <h2 className="contact-title">Contact & Support</h2>
      {/* <p className="contact-desc">We’re here to help you 24/7</p> */}

      <div className="contact-container">

        {/* Address */}
        <a
          href="https://www.google.com/maps?q=4-44/7,+R.B.+Cottage,+Karimaram,+Anucode,+Kollangodu,+Kanyakumari,+Tamil+Nadu,+629160"
          target="_blank"
          rel="noopener noreferrer"
          className="contact-card"
        >
          <MapPin className="contact-icon" />
          <h3 className="contact-heading">Address</h3>
          <p className="contact-text">
            4-44/7, R.B. Cottage, Karimaram, Anucode, Kollangodu, Kanyakumari, <br />
            Vilavancode, Tamil Nadu, India, 629160
          </p>
        </a>
        <a
          href="https://wa.me/917708342801"
          target="_blank"
          rel="noopener noreferrer"
          className="contact-card contact-card-whatsapp"
        >
          <div className="whatsapp-content">
            <img src={whatsappIcon} alt="WhatsApp" className="contact-icon" />
            <h3 className="contact-heading">Whatsapp</h3>
            <p className="contact-text">+91 77083 42801</p>
          </div>
        </a>


        {/* Phone */}
        <a href="tel:+919037642801" className="contact-card">
          <Phone className="contact-icon" />
          <h3 className="contact-heading">Phone</h3>
          <p className="contact-text">+91 90376 42801</p>
        </a>


        {/* Email */}
        <a href="mailto:miogracare@gmail.com" className="contact-card">
          <Mail className="contact-icon" />
          <h3 className="contact-heading">Email</h3>
          <p className="contact-text">miogracare@gmail.com</p>
        </a>

      </div>
    </section>
  );
};

export default Contact;
